// extracted by mini-css-extract-plugin
module.exports = {"settings":"settings_settings__QbnLm"};